import { Card, CardContent, Grid, Typography } from "@mui/material";

export default function OnlineCoverSheetHeader() {
  return (
    <Card
      sx={{
        width: "100%",
        backgroundColor: "myVerify.light",
        boxShadow: "0 16px #3E7787",
        marginBottom: 4,
      }}
    >
      <CardContent>
        <Grid
          item
          xs={10}
          sm={10}
          md={11}
          display="block"
          flexDirection="column"
          paddingLeft={3}
        >
          <Typography variant="h6" fontWeight={700} marginBottom={1}>
            Cover Sheet
          </Typography>
          <Typography marginBottom={1}>
            Use this page to create and customize your CDA Professional
            Portfolio Cover Sheet. You may choose to add an image, select the
            font style and color, and/or include a page border.
          </Typography>
        </Grid>
      </CardContent>
    </Card>
  );
}
